import { Alert, FormGroup } from "@mui/material";
import React, { useState } from "react";
import { Form } from "react-final-form";
import { useHistory } from "react-router";
import { Text } from "../../../common/components/input/Text";
import { LoadingButton } from "../../../common/components/LoadingButton";
import { Organization } from "../../../common/models";
import { Api } from "../../../common/service/Api";
import { RouteHelpers } from "../../root/routes";

export function NameLookupForm({
  org,
  limitToHrRequests = false,
}: {
  org: Organization;
  limitToHrRequests?: boolean;
}) {
  const [error, setError] = useState(null);
  const history = useHistory();

  const handleSubmit = async ({ subjectNameFirst, subjectNameLast }) => {
    try {
      let requests = await Api.dataRequest.getRequestsForConsumer(org.id, {
        subjectNameFirst: subjectNameFirst,
        subjectNameLast: subjectNameLast,
        subjectNameLimit: 1 /* Just look for one matching request for data presence, since we're running the query again very soon. */,
      });
      if (limitToHrRequests) {
        requests = requests.filter((request) => request.context === "EMPLOYEE");
      }
      if (requests.length > 0) {
        history.push(
          RouteHelpers.records.requestsResults({
            subjectNameFirst: subjectNameFirst,
            subjectNameLast: subjectNameLast,
          }),
        );
      } else {
        setError(
          `No requests found for ${
            (subjectNameFirst ?? "(any first name)") + " " + (subjectNameLast ?? "(any last name)")
          }`,
        );
      }
    } catch (err) {
      console.error(error);
      setError(err.message);
    }
  };

  return (
    <>
      {error && (
        <Alert color="error" className="mb-lg">
          {error}
        </Alert>
      )}
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, valid, submitting, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <FormGroup className="mb-md">
                <Text field="subjectNameFirst" label="Consumer First Name" />
                <Text field="subjectNameLast" label="Consumer Last Name" />
              </FormGroup>

              <LoadingButton
                loading={submitting}
                type="submit"
                variant="contained"
                disabled={
                  !valid || submitting || !(values?.subjectNameLast || values?.subjectNameFirst)
                }
              >
                Search
              </LoadingButton>
            </form>
          );
        }}
      />
    </>
  );
}
